<script>
  import { createEventDispatcher } from 'svelte'
  import filterClasses, { cssPrefix } from '../helper-classes.js'
  import { faBars, faTimes } from '@fortawesome/pro-regular-svg-icons'

  import { Icon, GL } from '../'

  export let style = null
  export let helperClass = null
  export let id = null

  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  let open = false
  const classes = [`${cssPrefix}navbar`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  const dispatch = createEventDispatcher()
  let burgerIcon
  $: burgerIcon = open ? faTimes : faBars

  function onHamburger(event) {
    open = !open
    dispatch('hamburger', event)
  }
</script>

<div class="theme-dark">
  <div class={classes.join(' ')} class:is-open={open} {style} {id}>
    <div class={`${cssPrefix}navbar-main`}>
      <a href="https://www.gl-systemhaus.de/en/" class={`${cssPrefix}navbar-brand`}>
        <GL light={true} />
      </a>
      <slot name="navbar-main" />

      <button on:click|preventDefault={onHamburger} class={`${cssPrefix}navbar-burger`}>
        <Icon icon={burgerIcon} />
      </button>
    </div>

    <div class={`${cssPrefix}navbar-menu`}>
      <slot />
    </div>
  </div>
</div>
